import styles from './GiftCardPage.module.scss';
import customStyles from './CustomClass.module.scss';

export const options = {
  customClasses: {
    panel: styles.panel,
  },
};

export const settingsSliderPerView = {
  desktopScreen: 5.3,
};

export const customClassesObj = {
  block: customStyles.block,
  imageTile: customStyles.imageTile,
};